module.exports = __webpack_public_path__ + "static/media/shopping.dd251088.jpg";